const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 841,
    lg: 1200,
    xl: 1536
  }
}

export default breakpoints
